import Vue from 'vue'
import { VueEditor } from 'vue2-editor'
Vue.use(VueEditor)

// for usage just
// <vue-editor v-model="content"></vue-editor>
